import React from "react";
import { Link } from "react-router-dom";
import { Modal } from "react-bootstrap";
import imageUrl from "utils/imageUrl";

const UnitBookedModal = (props) => {
  const handleClick = () => {
    props.handleActiveTab(3);
    props.onHide();
  };

  return (
    <Modal show={props.show} onHide={props.onHide}>
      <Modal.Header closeButton></Modal.Header>

      <div className="modal-body space-y-20 pd-40">
        <h4 className="pb-5">{props.title}</h4>

        <div className="hr"></div>
        <div className="img d-flex justify-content-center">
          <img
            src={imageUrl("icons/congrats.png")}
            alt="congrats.png"
            width={"35%"}
          />
        </div>
        <div className="d-flex justify-content-between">
          <p> Project Name:</p>
          <p className="text-right price color-popup"> Meezo </p>
        </div>
        <div className="d-flex justify-content-between">
          <p> Tower/Block:</p>
          <p className="text-right price color-popup"> A </p>
        </div>
        <div className="d-flex justify-content-between">
          <p> Level/Floor:</p>
          <p className="text-right price color-popup"> 28 </p>
        </div>
        <div className="d-flex justify-content-between">
          <p> Unit Number:</p>
          <p className="text-right price color-popup"> 6 </p>
        </div>
        <div className="d-flex justify-content-between">
          <p> Unit Price:</p>
          <p className="text-right price color-popup"> RM600 </p>
        </div>
        <p className="text-center pt-3">{props.para}</p>
        <Link
          to="/"
          className="btn btn-primary my-3"
          data-toggle="modal"
          data-target="#popup_bid_success"
          data-dismiss="modal"
          aria-label="Close"
          onClick={props.onHide}
        >
          {" "}
          Go To Home Page
        </Link>
        <Link
          to="/profile"
          className="btn btn-primary "
          data-toggle="modal"
          data-target="#popup_bid_success"
          data-dismiss="modal"
          aria-label="Close"
          // onClick={props.onHide}
          onClick={handleClick}
        >
          {" "}
          View your Property
        </Link>
      </div>
    </Modal>
  );
};

export default UnitBookedModal;
